<div class="main-content">
    <app-inbody *ngIf="specificProspectId.length > 0" [specificProspectId]="specificProspectId"></app-inbody>
</div>
